import savingActionTypes from '../../constants/saving-action-types';

const setSiteMeta = (selector, value) => ({
  type: savingActionTypes.SET_SITE_META,
  selector,
  value,
});

export default setSiteMeta;
